import { Tooltip } from '@mui/material';
import { MissingData } from '../enums/MissingDataEnum';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
dayjs.extend(isToday);
import { Typography } from '@mui/material';
import { renderTableCell } from './commonfunctions';

export const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
  };
  

  // export const dateFormat = (date) => {
  //   if (!date) return MissingData.NONE;
  
  //   const parsedDate = typeof date === "string" ? new Date(date) : date;
  
  //   return parsedDate instanceof Date && !isNaN(parsedDate)
  //     ? parsedDate.toLocaleString()
  //     : MissingData.NONE;
  // };

  export const dateFormat = (date, options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }) => {
    if (!date) return MissingData.NONE;
  
    const parsedDate = typeof date === "string" ? new Date(date) : date;
  
    if (!(parsedDate instanceof Date) || isNaN(parsedDate)) {
      return MissingData.NONE;
    }
  
    return parsedDate.toLocaleString("en-In", options).replace(",", " ·");
  };
  
  
  
  
export const renderDateCell = (params) => {
  const value = params?.value ? dateFormat(params?.value) : null;
  return renderTableCell(value)
};

export const formatDateCell = (value) => {
  if (!value) {
    return (
      <Tooltip title={MissingData.NO_DATA}>
        <span className="truncate">{MissingData.NONE}</span>
      </Tooltip>
    );
  }
  const dateObj = dayjs(value);
  const isDateToday = dateObj.isToday();
  const dateStr = isDateToday ? 'Today' : dateObj.format('MMM D, YYYY');
  const timeStr = dateObj.format('h:mm A');
  const fullStr = dateObj.format('MMM D, YYYY [at] h:mm A');
  return (
    <Tooltip title={fullStr}>
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
        <span>{dateStr}</span>
        <span style={{ fontSize: '0.85em', color: '#888' }}>{timeStr}</span>
      </span>
    </Tooltip>
  );
};